import { render, staticRenderFns } from "./BudgetType.vue?vue&type=template&id=04efbbce&scoped=true"
import script from "./BudgetType.vue?vue&type=script&lang=js"
export * from "./BudgetType.vue?vue&type=script&lang=js"
import style0 from "./BudgetType.vue?vue&type=style&index=0&id=04efbbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04efbbce",
  null
  
)

export default component.exports